export default "__VITE_ASSET__CIBu9nq9__"